import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './styles/globals.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: '#10141f',
          color: '#eef2ff',
          border: '1px solid #2a3555',
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '0.8rem',
          borderRadius: '10px',
        },
        success: { iconTheme: { primary: '#22c55e', secondary: '#040508' } },
        error:   { iconTheme: { primary: '#ff4d7a', secondary: '#040508' } },
      }}
    />
  </React.StrictMode>
);
